import * as React from 'react';
import b_ from 'b_';
import { compose } from 'recompose';
import { Link } from 'shared/components/Link';
import translate, { InjectedTranslateProps } from 'shared/utils/translate';
import MoneyView from 'shared/components/MoneyView';
import PercentView from 'components/PercentView';
import { StockFragment } from './__generated__/StockFragment';
import StockIcon from '../StockIcon';
import RiskInfo from 'components/RiskInfo';

import './index.scss';

interface Props {
  stock: StockFragment;
}

type Enhanced = Props & InjectedTranslateProps;

const enhance = compose<Enhanced, Props>(translate);

const b = b_.with('stock-view');

class StockView extends React.Component<Enhanced> {
  render() {
    const { t, stock } = this.props;

    const url = `/investments/stocks/${stock.id}`;

    return (
      <Link to={url} className={b()}>
        <div className={b('inner')}>
          <div className={b('row', { left: true })}>
            <StockIcon name={stock.name} url={stock.logoUrl} />
            <div className={b('description')}>
              <div title={stock.title} className={b('title')}>
                {stock.title}
              </div>
              <div className={b('type')}>
                <div>{t(stock.type)},</div>
                <div className={b('industry')}>{stock.sector}</div>
              </div>
            </div>
          </div>
          <div className={b('row', { right: true })}>
            <div className={b('risk-status')}>
              <RiskInfo withIcon shapedIcons>
                {stock.risk}
              </RiskInfo>
            </div>
            <div className={b('capitalization')}>
              <MoneyView compactNotation>{stock.capitalization}</MoneyView>
            </div>

            <div className={b('price')}>
              <MoneyView placeholder="-" compactNotation>
                {stock.price}
              </MoneyView>
            </div>
            <div className={b('column')}>
              <div
                className={b('price-change', {
                  positive: stock.priceDiff && stock.priceDiff > 0,
                  negative: stock.priceDiff && stock.priceDiff < 0,
                })}
              >
                {stock.priceDiff ? (
                  <PercentView precision={2} sign={false}>
                    {stock.priceDiff}
                  </PercentView>
                ) : (
                  '-'
                )}
              </div>
              <button className={b('btn')}>{t('Buy')}</button>
            </div>
          </div>
        </div>
      </Link>
    );
  }
}

export default enhance(StockView);
